import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-authenticate',
  templateUrl: './authenticate.component.html',
  styleUrls: ['./authenticate.component.less']
})
export class AuthenticateComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
